import React from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";

function EventScheduleList({className}) {
  return (
    <>
      <div className={`${className || ''} event-schedule-wrapper`}>
        <span>01</span>
        <div className="event-schedule-content">
          <div className="event-title d-flex align-items-center gap-2">
            <div className="event-img-wrapper">
              <img src={SampleImage2} alt="Event Image" className="img-fluid" />
            </div>
            <h1>PMP Exam Prep Seminar - 35 Complete Exam Coverage</h1>  
          </div>
          <div className="lecture-count">
            <p>No: of Lectures</p>
            <h1>06</h1>
          </div>
          <div className="lecture-venue">
            <p>Venue</p>
            <h1>Online</h1>
          </div>
          <div className="event-action-wrapper">
            <Button variant="outline" className="dark btn-round" size="sm">Start now</Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventScheduleList;
